import { useCallback } from "react";
import { useRoomContext } from "@livekit/components-react";
import type { ProviderUnblockAudio } from "../types";

export const useLivekitUnblockAudio = (): ProviderUnblockAudio => {
  const room = useRoomContext();

  const unblockAudio = useCallback(async () => {
    await room.startAudio();
  }, [room]);

  return {
    isAudioBlocked: !room.canPlaybackAudio,
    unblockAudio,
  };
};
